import React from 'react'
import { Player } from '@lottiefiles/react-lottie-player'
import card from 'src/assets/json/card.json'
import Icofont from 'react-icofont';

export const ClaveEsperaConfirmacion = () => {
    return (
        <div className="container">
            <div className="text-center">

                <Player
                    autoplay
                    loop
                    src={card}
                    style={{ height: "200px", width: "200px" }}
                />

                <h5 className="fw-bold text-dark">
                    Confirma tu pago con clave
                </h5>

                <p className="text-muted mb-4" style={{ fontSize: '14px' }}>
                    Completa el proceso de pago en la plataforma de <span className="text-danger fw-bold">Clave</span>.<br/>
                    Esta página se actualizará automáticamente cuando recibamos la confirmación.
                </p>

                <div
                    className="mx-auto p-3 rounded-4 border bg-light"
                    style={{ maxWidth: "550px" }}
                >
                    <div className="d-flex align-items-start">
                        <div
                            className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center me-3"
                            style={{ width: "70px", height: "42px" }}
                        >
                            <Icofont icon="lock" className="text-success" />
                        </div>

                        <div className="text-start">
                            <h6 className="fw-semibold mb-1">
                                Transacción protegida
                            </h6>

                            <small className="text-muted" style={{ fontSize: '12px' }}>
                                Tu información es transmitida de forma segura a través de la red
                                Clave de Telered. Nunca compartas tu PIN ni los datos de tu
                                tarjeta con terceros.
                            </small>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
